import React, { useState, useEffect, useRef, useMemo, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
import RssFeeds from "../rss/RssFeeds";
import { sources } from "../rss/RssSources";
import { Utils } from "../../utils";
import { getSessionData } from "../../utils/auth";
import EnvelopeOpen from "../icons/EnvelopeOpen";
import Feedback from "../icons/Feedback";
import Globe from "../icons/Globe";
import Ad from "../icons/Ad";
import { getPPList } from "../../core/forum_ads";
import FlagIcon from "../icons/Flag";
import { tourSteps } from "../../utils/tourData";

const INVITE_MODAL_EVENT = "wefayo-open-invite-modal";

const AsideRight = ({ className = "", forumId = "", onClickViewAllCommunities = () => { }, context = "desktop", communityBudges = {} }) => {
    const navigate = useNavigate();

    const [ads, setAds] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showGetStartedDialog, setShowGetStartedDialog] = useState(false);
    let loggedInUser = getSessionData();
    const wrapperRef = useRef(null);

    Utils.shuffle(sources);

    const handleGiveFeedback = () => {
        // console.log("give feedback");
    };

    const handleBack = () => {
        navigate(-1);
    };

    const handleInvite = () => {
        window.dispatchEvent(new CustomEvent(INVITE_MODAL_EVENT));
    };

    const displayContext = context;

    const handleViewAllCommunities = () => {
        // console.log("view all communities In Aside Right");
        onClickViewAllCommunities(displayContext);
    }

    // Same total that drives the Communities pill in NavHeader. Surfacing it
    // here gives mobile users a hint to tap "Select Community" and drill down
    // to the forum that triggered the badge.
    const totalNewPosts = useMemo(() => {
        if (!communityBudges || typeof communityBudges !== 'object') return 0;
        let n = 0;
        for (const key of Object.keys(communityBudges)) {
            const arr = communityBudges[key];
            if (Array.isArray(arr)) n += arr.length;
        }
        return n;
    }, [communityBudges]);

    const fetchPPListAds = async () => {
        setIsLoading(true);

        try {
            const data = await getPPList();
            setAds(data?.ads ?? []);
        } finally {
            setIsLoading(false);
        }
    }

    const fixPosition = () => {
        const mainRef = document.getElementById("main-ref");
        if (mainRef && wrapperRef && wrapperRef.current && context != "mobile") {
            const mainWidth = mainRef.getBoundingClientRect().width;
            const centerPoint = window.innerWidth / 2;
            const totalGaps = 8;
            let left = centerPoint + (mainWidth / 2) + totalGaps;
            const asideRightBuffer = document.getElementById("aside-right-buffer");
            if (asideRightBuffer) {
                left = asideRightBuffer.getBoundingClientRect().left;
                wrapperRef.current.style.left = `${Math.round(left)}px`;
            } else {
                wrapperRef.current.style.left = `${Math.round(left)}px`;
            }

        }
    }
    fixPosition();

    useEffect(() => {
        window.addEventListener("resize", fixPosition);
        return () => {
            window.removeEventListener("resize", fixPosition);
        };
    }, []);

    useEffect(() => {
        fetchPPListAds();
    }, []);

    return (
        <div
            ref={wrapperRef}
            className={`xaside-wrapper ${context == "mobile" ? "w-full" : "xfixed"} ${className}`}
        >
            <aside className={"mb-[5px] md:mb-0 rounded-md  w-full lg:w-80 shrink-0 flex flex-row lg:flex-col overflow-auto lg:overflow-['unset']  bg-white  "}>
                <div className="flex flex-col w-full overflow-hidden">

                    {(ads.length > 0 || context === "mobile") && (
                        <div className="flex flex-row items-center justify-between gap-x-1 gap-y-1 px-2 py-1.5  border-b border-gray-200 bg-primary-white flex-wrap">
                            {context === "mobile" && (
                                <button type="button" onClick={() => setShowGetStartedDialog(true)} className="flex flex-row items-center gap-x-2 px-2 py-1 text-sm font-semibold text-purple-900 hover:bg-purple-100 rounded-md cursor-pointer" aria-label="Get started">
                                    <FlagIcon className={"text-purple-900"} />
                                    Get Started
                                </button>
                            )}
                            <a href="mailto:support@wefayo.com" onClick={handleGiveFeedback} className="flex flex-row items-center gap-x-2 px-2 py-1 text-sm font-semibold text-purple-900 hover:bg-purple-100 rounded-md cursor-pointer">
                                <Feedback className="text-purple-900" />
                                Give Feedback
                            </a>

                        </div>
                    )}

                    <div className={`hidden md:block text-center font-bold py-2 mb-1  border-b md:border-0x border-gray-200 rounded-t-md  bg-primary-white`}>
                        {ads.length > 0 ? 'Premium Positioning' : 'Latest About Health'}
                    </div>

                    <div className="flex flex-row lg:flex-col ">

                        {(loggedInUser !== null && loggedInUser.role === "admin") &&
                            <a
                                className={
                                    `px-2 py-1.5 mb-1 even:bg-slate-100 odd:bg-white cursor-pointer flex flex-row justify-center items-center  text-purple-900 hidden lg:flex border-b border-gray-200`
                                }

                                href="/forumads"
                            >
                                <div className="min-w-[30px] h-[30px] flex justify-center items-center  ">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-6 w-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                    </svg>
                                </div>

                                <div className="text-sm font-bold flex flex-row items-center gap-x-1  ">
                                    Create PP
                                </div>
                            </a>
                        }

                        {ads.length > 0 &&
                            <div className="flex flex-row lg:flex-col gap-x-1 lg:gap-x-0 lg:gap-y-1 xoverflow-auto xl:overflow-['unset']x sm:rounded-sm p-1 lg:p-0 ">
                                {ads.map((ad, index) => {
                                    let logo = ad?.company_logo ?? "";
                                    let img = ad?.media ?? "";
                                    let style = {
                                        backgroundImage: `url('${img}')`,
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center'
                                    };
                                    const ky = index + Math.random() + Math.random();
                                    return (
                                        <div className="w-48 lg:w-full px-1 relative" key={ky}>
                                            <a
                                                className="cursor-pointer block"
                                                target="_blank"
                                                href={ad.url}>
                                                <div className="w-full h-[120px] xl:h-[150px] rounded-t-md  " style={style} ></div>
                                                {/* <image src={img} width="100px" height="100px" /> */}
                                                <div className="text-xs lg:text-md p-1 bg-slate-100 rounded-b-md lg:text-xs font-semibold font-medium line-clamp-1 lg:line-clamp-none" style={{ lineHeight: 1.5 }}>
                                                    {ad.title}
                                                </div>
                                                {logo.length > 0 &&
                                                    <img src={logo} className="absolute top-[10px] left-[10px] h-[40px] " />
                                                }
                                            </a>
                                        </div>
                                    );
                                })}
                            </div>
                        }
                        {(ads.length === 0 || true) &&
                            <div className="flex flex-row lg:flex-col gap-x-1 lg:gap-x-0 lg:gap-y-1 lg:pt-1 xoverflow-auto xl:overflow-['unset']x sm:rounded-sm p-1 lg:p-0 ">
                                {sources.map((source, index) => {
                                    return (<RssFeeds key={index} source={source} />)
                                })}
                            </div>
                        }
                    </div>
                </div>
            </aside>

            <div className="flex flex-row  justify-between gap-y-1 lg:gap-y-0 bg-white   rounded-t-md md:hidden">
                <button onClick={handleViewAllCommunities} className="gap-x-2 flex py-2 lg:hidden flex flex-row justify-between items-center px-2 text-center text-white font-bold py-1 border-b rounded-br-[15px] rounded-tl-md rounded-tr-md border-gray-200 md:border-0 bg-purple-900 hover:bg-purple-800  cursor-pointer ">
                    <span className="flex flex-row items-center gap-x-2">
                        Select Community
                        {totalNewPosts > 0 && (
                            <span
                                className="bg-red-600 text-white rounded-full text-[10px] leading-none px-1.5 py-0.5 min-w-[18px] text-center font-semibold"
                                aria-label={`${totalNewPosts} new post${totalNewPosts === 1 ? '' : 's'}`}
                            >
                                {totalNewPosts}
                            </span>
                        )}
                    </span>
                    {/* <Globe className={"text-white"} /> */}

                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
  <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5" />
</svg>

                </button>

                <button type="button" onClick={handleInvite} className="flex flex-row items-center gap-x-2 px-2 py-1 text-sm font-semibold text-purple-900 hover:bg-purple-100 rounded-md cursor-pointer" aria-label="Invite friends">
                    <EnvelopeOpen className="text-purple-900" />
                    Invite Friends
                </button>

                {/* <a onClick={handleGiveFeedback} href="mailto:support@wefayo.com" className="gap-x-2 flex w-fit lg:w-full flex flex-row justify-between items-center px-2 text-center text-white font-bold py-1 border-b rounded-md border-gray-200 md:border-0 bg-purple-900 hover:bg-purple-800  cursor-pointer ">
                    Give Feedback
                    <EnvelopeOpen className={"text-white"} />
                </a> */}
            </div>

            {/* Get Started instructions dialog */}
            <Transition.Root show={showGetStartedDialog} as={Fragment}>
                <Dialog as="div" className="relative" style={{ zIndex: 99 }} open={showGetStartedDialog} onClose={() => setShowGetStartedDialog(false)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-600 bg-opacity-75 transition-opacity" onClick={() => setShowGetStartedDialog(false)} />
                    </Transition.Child>
                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4"
                                enterTo="opacity-100 translate-y-0"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0"
                                leaveTo="opacity-0 translate-y-4"
                            >
                                <Dialog.Panel className="relative w-full max-w-md transform overflow-hidden rounded-lg bg-white shadow-xl transition-all text-left">
                                    <div className="px-4 pt-4 pb-2 flex justify-between items-center border-b border-gray-200">
                                        <Dialog.Title className="text-lg font-bold text-purple-900">Get Started on Mobile</Dialog.Title>
                                        <button type="button" className="text-gray-500 hover:text-gray-700 text-xl leading-none" onClick={() => setShowGetStartedDialog(false)} aria-label="Close">×</button>
                                    </div>
                                    <div className="px-4 py-4 space-y-4 max-h-[70vh] overflow-y-auto">
                                        {tourSteps.map((step, index) => (
                                            <section key={step.target}>
                                                <h3 className="text-sm font-semibold text-purple-900 mb-1">
                                                    {index + 1}. {step.title}
                                                </h3>
                                                <p className="text-sm text-gray-600">{step.content}</p>
                                            </section>
                                        ))}
                                    </div>
                                    <div className="px-4 py-3 bg-gray-50 rounded-b-lg border-t border-gray-200">
                                        <button type="button" className="w-full py-2 text-sm font-semibold text-white bg-purple-900 hover:bg-purple-800 rounded-md" onClick={() => setShowGetStartedDialog(false)}>Got it</button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>

    );
};



export default AsideRight;
